import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from './../environments/environment';
import { ReportService } from './services/report.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './components/ui/confirmation-dialog/confirmation-dialog.component';
import { MailerService } from './services/mailer.service';
import { FirebaseUtilitiesService } from './services/firebase-utilities.service';
import { ThemeService } from './services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'vna';
  maintenance: boolean;
  private notificationListener?: (event: CustomEvent) => void;

  constructor(
    public rs: ReportService,
    private dialog: MatDialog,
    private mailer_$: MailerService,
    private firebaseUtilitiesService_$: FirebaseUtilitiesService,
    // Injected here to ensure theme is applied on app startup before any component renders
    private theme_$: ThemeService
  ) {}

  ngOnInit() {
    this.maintenance = environment.maintenance;

    // Listen for facility notification from Chrome extension
    this.notificationListener = (event: CustomEvent) => {
      this.showFacilityNotificationDialog(
        event.detail?.message || 'The confirmation email has been sent to the facilitators'
      );

      // Mark the patient as shared
      this.firebaseUtilitiesService_$
        .updatePatientSharedWithFacility(undefined, undefined, undefined, true)
        .then(() => {
          console.log('Patient marked as shared');
        })
        .catch(error => {
          console.error('Error marking patient as shared:', error);
          this.showFacilityNotificationDialog('Error marking patient as shared. Please try again later.');
        });

      // Send email notification to facilitators
      this.mailer_$
        .sendSendImagesEmailNotification()
        .then(() => {
          console.log('Email sent');
        })
        .catch(error => {
          console.error('Error sending email:', error);
          this.showFacilityNotificationDialog('Error sending email. Please try again later.');
        });
    };

    window.addEventListener('nuagedx-facility-notification', this.notificationListener as EventListener);
    document.addEventListener('nuagedx-facility-notification', this.notificationListener as EventListener);

    // NOTE: Need to check error generated here before activate it back.
    /* this.rs.getTotalFileUsageSizeForClient('b2cxuGqm9XbUNLn0p8NYwgcJ9y03').then((totalSize) => {
      console.log(totalSize);
    }); */
  }

  ngOnDestroy() {
    if (this.notificationListener) {
      window.removeEventListener('nuagedx-facility-notification', this.notificationListener as EventListener);
      document.removeEventListener('nuagedx-facility-notification', this.notificationListener as EventListener);
    }
  }

  private showFacilityNotificationDialog(message: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.data = {
      title: 'Notification Sent',
      message: message,
      btnOkText: 'OK',
      btnCancelText: 'Close'
    };

    this.dialog.open(ConfirmationDialogComponent, dialogConfig);
  }
}
